<template>
  <div class="debug-container">
    <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',padding:'1px'}"
              :row-style="{height: '0'}"
              :cell-style="{padding: '0'}"
              stripe
              :height="tableHeight"
              size="mini"
              style="width: 100%"
              :data="debugInfos">
      <el-table-column prop="date"
                       label="time"
                       width="180">
      </el-table-column>
      <el-table-column prop="name"
                       label="name"
                       width="200">
      </el-table-column>
      <el-table-column prop="desc"
                       label="description">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data () {
    return {
      tableHeight: '',
    };
  },
  computed: {
    ...mapState([
      'debugInfos',
    ]),
  },
  created () {
    this.setPageNow('DebugPage');
    this.setHomeHidden(false);
    this.setShowSidebar(false);
    this.setShowFooter(false);
    window.addEventListener('resize', this.getHeight);
    this.tableHeight = window.innerHeight - 75;
  },
  methods: {
    ...mapMutations(['setHomeHidden', 'setShowSidebar', 'setShowFooter', 'setPageNow']),
    getHeight () {
      this.tableHeight = window.innerHeight - 75;
    },
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight);
  },
};
</script>

<style lang="scss" scoped>
.debug-container {
}
</style>
